<nb-card size="large">
  <nb-card-header>
     <div class="row">
        <div class="col-12" *ngIf="_currentRegistro.recordType == 'SIEMBRA'">
          <h4 style="display: inline;">
          <img [src]="imagesBaseUrl + '/assets/images/icSiembra.png'" class="record-type-img"/> Siembra en {{_currentRegistro.recordData.parcelaName}}
          </h4>
          <span >({{ getGroupUserEmail(_currentRegistro.userAuthor) }})</span>
        </div>
        <div class="col-12" *ngIf="_currentRegistro.recordType == 'TRATAMIENTO'"><h4>
          <img [src]="imagesBaseUrl + '/assets/images/icTratamiento.png'" class="record-type-img"/> Tratamiento en {{_currentRegistro.recordData.parcelaName}}
          </h4>
        </div>
        <div class="col-12" *ngIf="_currentRegistro.recordType == 'COSECHA'"><h4>
          <img [src]="imagesBaseUrl + '/assets/images/icCosecha.png'" class="record-type-img"/> Cosecha en {{_currentRegistro.recordData.parcelaName}}
          </h4>
        </div>
        <div class="col-12" *ngIf="_currentRegistro.recordType == 'GEOFOTO'"><h4>
          <img [src]="imagesBaseUrl + '/assets/images/icGeofoto.png'" class="record-type-img"/> Geofoto en {{_currentRegistro.recordData.parcelaName}}
          </h4>
        </div>
        <div class="col-12" *ngIf="_currentRegistro.recordType == 'FERTILIZACION'"><h4>
          <img [src]="imagesBaseUrl + '/assets/images/icFertilizacion.png'" class="record-type-img"/> Fertilización en {{_currentRegistro.recordData.parcelaName}}
          </h4>
        </div>
     </div>

  </nb-card-header>

  <nb-card-body *ngIf="_currentRegistro.recordType == 'SIEMBRA'">
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label for="alias" class="label">Tipo de Siembra</label>
                <ngx-item-selector [jsonSource]="'../assets/jsondata/tipoSiembra.json'" [(selectedData)]="_currentRegistro.recordData.tipo"></ngx-item-selector>
            </div>
          </div>

          <div class="col-sm-6">
            <label for="alias" class="label">Producto</label>
            <ngx-item-selector [jsonSource]="'../assets/jsondata/productos.json'" [(selectedData)]="_currentRegistro.recordData.producto"></ngx-item-selector>

          </div>

        </div>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label for="fechaini" class="label">Fecha de inicio</label>
              <input nbInput fullWidth [nbDatepicker]="datepickerFechaini" [(ngModel)]="_currentRegistro.recordData.fechaInicio" (blur)="handleDateInput($event,'fIni')">
              <nb-datepicker format="dd/MM/yyyy" #datepickerFechaini></nb-datepicker>
              <div *ngIf="errorMessageIni" class="error-message">
                {{ errorMessageIni }}
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label for="fechafin" class="label">Fecha de fin</label>
              <input nbInput fullWidth [nbDatepicker]="datepickerFechafin" [(ngModel)]="_currentRegistro.recordData.fechaFin" (blur)="handleDateInput($event,'fFin')">
              <nb-datepicker format="dd/MM/yyyy" #datepickerFechafin></nb-datepicker>
              <div *ngIf="errorMessageFin" class="error-message">
                {{ errorMessageFin }}
              </div>
            </div>
          </div>

        </div>

        <div class="row" *ngIf="_currentRegistro.recordData.tipo.identifier == '1'">
          <div class="col-sm-6">
            <div class="form-group">
              <label for="cantidad" class="label">Cantidad (Kg. Semilla)</label>
              <input nbInput fullWidth type="number" [(ngModel)]="_currentRegistro.recordData.cantidad">
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label fullWidth for="siembradirecta" class="label fullwidth">&nbsp;</label>
              <nb-toggle [(checked)]="_currentRegistro.recordData.siembraDirecta" labelPosition="right">Siembra directa</nb-toggle>
            </div>
          </div>

        </div>
        <div class="row" *ngIf="_currentRegistro.recordData.tipo.identifier == '2'">
          <div class="col-sm-6">
            <div class="form-group">
              <label for="densidad" class="label">Densidad plantación (plantas/ha)</label>
              <input nbInput fullWidth type="number" [(ngModel)]="_currentRegistro.recordData.densidadPlantacion">
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label fullWidth for="marco" class="label">Marco de plantación</label>
              <input nbInput fullWidth [(ngModel)]="_currentRegistro.recordData.marcoPlantacion">
            </div>
          </div>

        </div>

        <div class="row" *ngIf="_currentRegistro.recordData.producto.identifier == 80">
          <div class="col-sm-6">
            <label for="fechainundacion" class="label">Fecha de inundacion</label>
            <input nbInput fullWidth [nbDatepicker]="datepickerFechainundacion" [(ngModel)]="_currentRegistro.recordData.fechaInundacion" (blur)="handleDateInput($event,'fInun')">
            <nb-datepicker format="dd/MM/yyyy" #datepickerFechainundacion></nb-datepicker>
            <div *ngIf="errorMessageInun" class="error-message">
              {{ errorMessageInun }}
            </div>
          </div>
        </div>
        <div class="row" *ngIf="_currentRegistro.recordData.producto.identifier == 82">
          <div class="col-sm-6">
            <label for="unidadesremolacha" class="label">Unidades de remolacha</label>
            <input nbInput fullWidth type="number" [(ngModel)]="_currentRegistro.recordData.unidadesRemolacha">
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <label for="observaciones" class="label">Observaciones</label>
            <textarea nbInput fullWidth placeholder="Observaciones" [(ngModel)]="_currentRegistro.recordData.observaciones"></textarea>
          </div>
        </div>
        <div  *ngIf="_currentRegistro.syncCUE && _currentRegistro.syncCUE.status =='ERROR'" class="row"><div class="col-sm-12"><p class="error">{{_currentRegistro.syncCUE.message}}</p> </div></div>
         <div class="row mt-4">
            <div class="col-sm-5">
              <button nbButton fullWidth status="basic" (click)="closeRegistro()">Cerrar</button>
            </div>
            <div class="col-sm-2">
              <button nbButton fullWidth status="danger" [disabled]="_currentRegistro.userAuthor && vUser != _currentRegistro.userAuthor" (click)="promptDeleteRegistro()">Eliminar</button>
            </div>
            <div class="col-sm-5">
              <button nbButton fullWidth status="success" [disabled]="_currentRegistro.userAuthor && vUser != _currentRegistro.userAuthor" (click)="updateRegistro()">Guardar</button>
            </div>
        </div>


  </nb-card-body>

  <nb-card-body *ngIf="_currentRegistro.recordType == 'COSECHA'">
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label for="alias" class="label">Tipo de Recolección</label>
            <ngx-item-selector [jsonSource]="'../assets/jsondata/tipoCosecha.json'" [(selectedData)]="_currentRegistro.recordData.tipo"></ngx-item-selector>
        </div>
      </div>

      <div class="col-sm-6">
        <label for="alias" class="label">Producto Vegetal</label>
        <ngx-item-selector [dataSource]="productosCosechados" [(selectedData)]="_currentRegistro.recordData.producto"></ngx-item-selector>
      </div>

    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label for="fechaini" class="label">Fecha de inicio</label>
          <input nbInput fullWidth [nbDatepicker]="datepickerFechaini" [(ngModel)]="_currentRegistro.recordData.fechaInicio" (blur)="handleDateInput($event,'fIni')">
          <nb-datepicker format="dd/MM/yyyy" #datepickerFechaini></nb-datepicker>
          <div *ngIf="errorMessageIni" class="error-message">
            {{ errorMessageIni }}
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="fechafin" class="label">Fecha de fin</label>
          <input nbInput fullWidth [nbDatepicker]="datepickerFechafin" [(ngModel)]="_currentRegistro.recordData.fechaFin" (blur)="handleDateInput($event,'fFin')">
          <nb-datepicker format="dd/MM/yyyy" #datepickerFechafin></nb-datepicker>
          <div *ngIf="errorMessageFin" class="error-message">
            {{ errorMessageFin }}
          </div>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label for="cantidad" class="label">Cantidad</label>
          <input nbInput fullWidth type="number" [(ngModel)]="_currentRegistro.recordData.cantidad">
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="unidad" class="label">Unidades</label>
          <ngx-item-selector [jsonSource]="'../assets/jsondata/unidades_tipo05.json'" [(selectedData)]="_currentRegistro.recordData.unidad"></ngx-item-selector>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <label for="finalidad" class="label">Finalidad de la cosecha</label>
        <ngx-item-selector multi="true"
        [jsonSource]="'../assets/jsondata/finalidadCosecha.json'"
        [(selectedData)]="_currentRegistro.recordData.finalidadCosecha">
      </ngx-item-selector>
      </div>
    </div>


    <div class="row">
      <div class="col-sm-12">
        <label for="destino" class="label">Destino del resto vegetal</label>
        <ngx-item-selector multi="true"
          [jsonSource]="'../assets/jsondata/destinoRestoVegetal.json'"
          [(selectedData)]="_currentRegistro.recordData.destinoRestoVegetal">
        </ngx-item-selector>
      </div>
    </div>
    <div  *ngIf="_currentRegistro.syncCUE && _currentRegistro.syncCUE.status =='ERROR'" class="row"><div class="col-sm-12"><p class="error">{{_currentRegistro.syncCUE.message}}</p> </div></div>
    <div class="row mt-4">
        <div class="col-sm-5">
          <button nbButton fullWidth status="basic" (click)="closeRegistro()">Cerrar</button>
        </div>
        <div class="col-sm-2">
          <button nbButton fullWidth status="danger" [disabled]="vUser != _currentRegistro.userAuthor" (click)="promptDeleteRegistro()">Eliminar</button>
        </div>
        <div class="col-sm-5">
          <button nbButton fullWidth status="success" [disabled]="vUser != _currentRegistro.userAuthor" (click)="updateRegistro()">Guardar</button>
        </div>
    </div>
    </nb-card-body>

    <nb-card-body *ngIf="_currentRegistro.recordType == 'TRATAMIENTO'">
      <div class="row">
        <div class="col-sm-8">
          <label for="cultivo" class="label">Cultivo</label>
          <ngx-item-selector [jsonSource]="'../assets/jsondata/productos.json'" [(selectedData)]="_currentRegistro.recordData.producto"></ngx-item-selector>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-8">
          <label for="tipoProblematica" class="label">Tipo de problemática</label>
          <ngx-item-selector
          [jsonSource]="'../assets/jsondata/tipoProblematica.json'"
          [(selectedData)]="_currentRegistro.recordData.tipoProblematica"
          (selectedDataChange)="onTipoProblematicaChange($event)">
        </ngx-item-selector>

        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <label for="problematica" class="label">Problemática</label>

          <ngx-item-searchable *ngIf="_currentRegistro.recordData.tipoProblematica"
          no-items-message="No se han encontrado problemáticas para seleccionar"
              [jsonSource]="_currentRegistro.recordData.tipoProblematica.problematicaDataSource"
              [(selectedData)]="_currentRegistro.recordData.problematica"
              (selectedDataChange)="onProblematicaChange($event)">

          </ngx-item-searchable>

        </div>
      </div>


      <div class="row">
        <div class="col-sm-12">
          <label for="justificacion" class="label">Justificación</label>
          <ngx-item-selector multi="true" [jsonSource]="'../assets/jsondata/justificacionMedida.json'"
          [(selectedData)]="_currentRegistro.recordData.justificacion" ></ngx-item-selector>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4">
          <div class="form-group">
            <label for="fechaini" class="label">Fecha de inicio</label>
            <input nbInput fullWidth [nbDatepicker]="datepickerFechaini" [(ngModel)]="_currentRegistro.recordData.fechaInicio" (blur)="handleDateInput($event,'fIni')">
            <nb-datepicker format="dd/MM/yyyy" #datepickerFechaini></nb-datepicker>
            <div *ngIf="errorMessageIni" class="error-message">
              {{ errorMessageIni }}
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label for="fechafin" class="label">Fecha de fin</label>
            <input nbInput fullWidth [nbDatepicker]="datepickerFechafin" [(ngModel)]="_currentRegistro.recordData.fechaFin" (blur)="handleDateInput($event,'fFin')">
            <nb-datepicker format="dd/MM/yyyy" #datepickerFechafin></nb-datepicker>
            <div *ngIf="errorMessageFin" class="error-message">
              {{ errorMessageFin }}
            </div>
          </div>
        </div>

      </div>

      <div class="row">
        <div class="col-sm-4">
          <div class="form-group">
            <label for="superficie" class="label">Superficie</label>
            <input nbInput fullWidth type="number" [(ngModel)]="_currentRegistro.recordData.superficie">
          </div>
        </div>
        <div class="col-sm-8">
          <div class="form-group">
            <label fullWidth for="tipoMedida" class="label fullwidth">Tipo de medida</label>
            <ngx-item-selector [jsonSource]="'../assets/jsondata/tipoAlternativa.json'" [(selectedData)]="_currentRegistro.recordData.tipoMedida"></ngx-item-selector>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label for="productoMedida" class="label">Producto / Medida</label>


            <ngx-item-searchable *ngIf="_currentRegistro.recordData.tipoMedida.identifier == '1'"
                      no-items-message="No se han encontrado productos fitosanitarios que cumplan las restricciones indicadas"
                      [getKey]="calcularIdProductoFito" [renderValue]="calcularLabelProductoFito"
                      [dataSource]="productosFitosanitarios"
                      [(selectedData)]="_currentRegistro.recordData.productoMedida"
                      (selectedDataChange)="onProductoChange($event)">
          </ngx-item-searchable>
            <ngx-item-selector *ngIf="_currentRegistro.recordData.tipoMedida.identifier == '2'"
                               [jsonSource]="'../assets/jsondata/tipo_medida_fitosanitaria.json'"
                               [(selectedData)]="_currentRegistro.recordData.productoMedida">
            </ngx-item-selector>

          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4">
          <label for="cantidad" class="label">Cantidad</label>
          <input nbInput fullWidth type="number" [(ngModel)]="_currentRegistro.recordData.cantidad">
        </div>
        <div class="col-sm-4">
          <label for="unidad" class="label">Unidades</label>
          <ngx-item-selector [jsonSource]="'../assets/jsondata/unidades_tipo00.json'" [(selectedData)]="_currentRegistro.recordData.unidad"></ngx-item-selector>
        </div>
        <div class="col-sm-4">
          <label for="registro" class="label">Registro</label>
          <input nbInput fullWidth [(ngModel)]="_currentRegistro.recordData.registro">
        </div>
      </div>

      <div class="row mt-4 mb-5">
        <div class="col-sm-10">
          <label for="equipos" class="label">Equipos / Aplicadores</label>
          <ngx-equipo-aplicador [(equipos-aplicadores)]="_currentRegistro.recordData.equipoAplicador">
          </ngx-equipo-aplicador>

        </div>
      </div>



      <div class="row">
        <div class="col-sm-4">
          <label for="efeicacia" class="label">Eficacia</label>
          <ngx-item-selector [jsonSource]="'../assets/jsondata/eficaciaTratamiento.json'" [(selectedData)]="_currentRegistro.recordData.eficaciaMedida"></ngx-item-selector>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <label for="observaciones" class="label">Observaciones</label>
          <textarea nbInput fullWidth placeholder="Observaciones" [(ngModel)]="_currentRegistro.recordData.observaciones"></textarea>
        </div>
      </div>
      <div  *ngIf="_currentRegistro.syncCUE && _currentRegistro.syncCUE.status =='ERROR'" class="row"><div class="col-sm-12"><p class="error">{{_currentRegistro.syncCUE.message}}</p> </div></div>
      <div class="row mt-4">
          <div class="col-sm-5">
            <button nbButton fullWidth status="basic" (click)="closeRegistro()">Cerrar</button>
          </div>
          <div class="col-sm-2">
            <button nbButton fullWidth status="danger" [disabled]="vUser != _currentRegistro.userAuthor" (click)="promptDeleteRegistro()">Eliminar</button>
          </div>
          <div class="col-sm-5">
            <button nbButton fullWidth status="success" [disabled]="vUser != _currentRegistro.userAuthor" (click)="updateRegistro()">Guardar</button>
          </div>
      </div>


</nb-card-body>

<nb-card-body *ngIf="_currentRegistro.recordType == 'FERTILIZACION'">


      <div class="row">
        <div class="col-sm-4">
            <div class="form-group">
              <label fullWidth for="declaraBuenasPracticas" class="label fullwidth">&nbsp;</label>
              <nb-toggle [(checked)]="_currentRegistro.recordData.declaraBuenasPracticas" labelPosition="right">Declara buenas prácticas</nb-toggle>
            </div>
        </div>
        <div class="col-sm-8" *ngIf="_currentRegistro.recordData.declaraBuenasPracticas">
          <label for="buenasPracticas" class="label">Buenas prácticas</label>
          <ngx-item-selector multi="true" [jsonSource]="'../assets/jsondata/buenasPracticasFertilizantes.json'"
          [(selectedData)]="_currentRegistro.recordData.buenasPracticas"
          (selectedDataChange)="checkFertirrigacion($event)" ></ngx-item-selector>
        </div>
      </div>

      <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label for="fechaini" class="label">Fecha de inicio</label>
              <input nbInput fullWidth [nbDatepicker]="datepickerFechaini" [(ngModel)]="_currentRegistro.recordData.fechaInicio" (blur)="handleDateInput($event,'fIni')">
              <nb-datepicker format="dd/MM/yyyy" #datepickerFechaini></nb-datepicker>
              <div *ngIf="errorMessageIni" class="error-message">
                {{ errorMessageIni }}
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label for="fechafin" class="label">Fecha de fin</label>
              <input nbInput fullWidth [nbDatepicker]="datepickerFechafin" [(ngModel)]="_currentRegistro.recordData.fechaFin" (blur)="handleDateInput($event,'fFin')">
              <nb-datepicker format="dd/MM/yyyy" #datepickerFechafin></nb-datepicker>
              <div *ngIf="errorMessageFin" class="error-message">
                {{ errorMessageFin }}
              </div>
            </div>
          </div>

      </div>

      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="tipoFertilizante" class="label">Tipo de fertilización</label>
            <ngx-item-selector [jsonSource]="'../assets/jsondata/tipoFertilizacion.json'"
            [(selectedData)]="_currentRegistro.recordData.tipoFertilizante" ></ngx-item-selector>
          </div>

        </div>
         <div class="col-sm-6">
          <div class="form-group">
            <label for="materialFertilizante" class="label">Material fertilizante</label>
            <ngx-item-selector [jsonSource]="'../assets/jsondata/materialFertilizante.json'"
            [(selectedData)]="_currentRegistro.recordData.materialFertilizante"
            (selectedDataChange)="filtrarMaterialFertilizante()"></ngx-item-selector>
          </div>

        </div>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
                <label for="metodoFertilizacion" class="label">Método de aplicación</label>
              <ngx-item-selector [jsonSource]="'../assets/jsondata/metodoAplicacionFertilizantes.json'"
              [(selectedData)]="_currentRegistro.recordData.metodoFertilizacion"
              (selectedDataChange)="checkFertirrigacion($event)"></ngx-item-selector>
          </div>

        </div>
         <div class="col-sm-6">
          <div class="form-group">
            <label for="productoFertilizante" class="label">Producto fertilizante</label>
            <ngx-item-selector [dataSource]="productoFertilizante"
            [(selectedData)]="_currentRegistro.recordData.productoFertilizante" ></ngx-item-selector>
          </div>

        </div>
      </div>

      <div class="row">

        <div class="col-sm-12">
          <div class="form-group">
                 <label for="composicion" class="label">Composición de producto Fertilizante</label>
                  <ngx-composicion-producto [(composicion)]="_currentRegistro.recordData.composicionFertilizante"></ngx-composicion-producto>
          </div>

        </div>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="cantidad" class="label">Dosis</label>
            <input nbInput fullWidth type="number" [(ngModel)]="_currentRegistro.recordData.dosis">
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for="unidad" class="label">Unidad</label>
            <ngx-item-selector [jsonSource]="'../assets/jsondata/unidades_tipo06.json'" [(selectedData)]="_currentRegistro.recordData.unidad"></ngx-item-selector>
          </div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-8">
          <label for="tratamientoEstiercoles" class="label">Tratamiento de estiércoles</label>
          <ngx-item-selector [jsonSource]="'../assets/jsondata/tratamientoEstiercoles.json'"
          [(selectedData)]="_currentRegistro.recordData.tratamientoEstiercoles" ></ngx-item-selector>
        </div>
        <div class="col-sm-4">
            <div class="form-group">
              <label fullWidth for="aplicacionLodos" class="label fullwidth">&nbsp;</label>
              <nb-toggle [(checked)]="_currentRegistro.recordData.aplicacionLodos" labelPosition="right">Aplicación de lodos</nb-toggle>
            </div>
        </div>

    </div>

    <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
             <label for="equipoAplicador" class="label">Equipo aplicador</label>
            <ngx-item-selector [dataSource]="equipos" [(selectedData)]="_currentRegistro.recordData.equipo"></ngx-item-selector>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
             <label for="registroRegfer" class="label">Registro REGFER</label>
            <input nbInput fullWidth [(ngModel)]="_currentRegistro.recordData.registroRegfer">
          </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
          <label for="buenasPracticasRiego" class="label">Buenas prácticas de riego</label>
          <ngx-item-selector [jsonSource]="'../assets/jsondata/buenasPracticasRiego.json'"
          [(selectedData)]="_currentRegistro.recordData.buenasPracticasRiego" ></ngx-item-selector>
          </div>
        </div>
     </div>
     <div *ngIf="enableFertirrigacion">
        <label class="label">Fertirrigación</label>
        <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
              <label for="sistemaRiego" class="label">Sistema de riego</label>
              <ngx-item-selector [jsonSource]="'../assets/jsondata/sistemaRiego.json'"
              [(selectedData)]="_currentRegistro.recordData.fertirrigacion.sistemaRiego" ></ngx-item-selector>
              </div>
            </div>
        </div>
          <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="cantidad" class="label">Cantidad</label>
                  <input nbInput fullWidth type="number" [(ngModel)]="_currentRegistro.recordData.fertirrigacion.cantidad">
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="unidad" class="label">Unidad</label>
                  <ngx-item-selector [jsonSource]="'../assets/jsondata/unidades_tipo07.json'" [(selectedData)]="_currentRegistro.recordData.fertirrigacion.unidad"></ngx-item-selector>
                </div>
              </div>
          </div>
          <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="origenAgua" class="label">Origen del agua</label>
                  <ngx-item-selector multi="true" [jsonSource]="'../assets/jsondata/origenAgua.json'" [(selectedData)]="_currentRegistro.recordData.fertirrigacion.origenAgua"></ngx-item-selector>

                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="numeroContador" class="label">Número del contador</label>
                  <input nbInput fullWidth [(ngModel)]="_currentRegistro.recordData.fertirrigacion.numeroContador">
                </div>
              </div>
          </div>
          <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="dosisN" class="label">N Nítrico del agua</label>
                  <input nbInput fullWidth type="number" [(ngModel)]="_currentRegistro.recordData.fertirrigacion.dosisN">
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="unidad" class="label">Unidad N Nítrico</label>
                  <ngx-item-selector [jsonSource]="'../assets/jsondata/unidades_tipo08.json'" [(selectedData)]="_currentRegistro.recordData.fertirrigacion.unidadDosisN"></ngx-item-selector>
                </div>
              </div>
          </div>
          <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="dosisP" class="label">P205 soluble en agua</label>
                  <input nbInput fullWidth type="number" [(ngModel)]="_currentRegistro.recordData.fertirrigacion.dosisP">
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="unidad" class="label">Unidad P205</label>
                  <ngx-item-selector [jsonSource]="'../assets/jsondata/unidades_tipo08.json'" [(selectedData)]="_currentRegistro.recordData.fertirrigacion.unidadDosisP"></ngx-item-selector>
                </div>
              </div>
          </div>
     </div>

     <div  *ngIf="_currentRegistro.syncCUE && _currentRegistro.syncCUE.status =='ERROR'" class="row"><div class="col-sm-12"><p class="error">{{_currentRegistro.syncCUE.message}}</p> </div></div>

       <div class="row mt-4">
          <div class="col-sm-5">
            <button nbButton fullWidth status="basic" (click)="closeRegistro()">Cerrar</button>
          </div>
          <div class="col-sm-2">
            <button nbButton fullWidth status="danger" [disabled]="vUser != _currentRegistro.userAuthor" (click)="promptDeleteRegistro()">Eliminar</button>
          </div>
          <div class="col-sm-5">
            <button nbButton fullWidth status="success" [disabled]="vUser != _currentRegistro.userAuthor" (click)="updateRegistro()">Guardar</button>
          </div>
      </div>
</nb-card-body>

<nb-card-body *ngIf="_currentRegistro.recordType == 'GEOFOTO'">

  <div class="row">
    <div class="col-sm-12">
      <label for="observaciones" class="label">Uso</label>
      <input nbInput fullWidth type="text" [(ngModel)]="_currentRegistro.recordData.uso">
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12">
      <label for="observaciones" class="label">Observaciones</label>
      <textarea nbInput fullWidth placeholder="Observaciones" [(ngModel)]="_currentRegistro.recordData.observaciones"></textarea>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <label for="imagen" class="label">Imagen</label>
        <img [src]="imageUrl" style="width:100%;min-height: 100px;"/>
      </div>
  </div>


  <div class="row mt-4">
      <div class="col-sm-5">
        <button nbButton fullWidth status="basic" (click)="closeRegistro()">Cerrar</button>
      </div>
      <div class="col-sm-2">
        <button nbButton fullWidth status="danger" [disabled]="vUser != _currentRegistro.userAuthor" (click)="promptDeleteRegistro()">Eliminar</button>
      </div>
      <div class="col-sm-5">
        <button nbButton fullWidth status="success" [disabled]="vUser != _currentRegistro.userAuthor" (click)="updateRegistro()">Guardar</button>
      </div>
  </div>


</nb-card-body>

</nb-card>

<ng-template #deleteconfirmation let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-header>Eliminar Registro </nb-card-header>
    <nb-card-body>¿Realmente desea eliminar este registro de su cuaderno de actividad?
    </nb-card-body>
    <nb-card-footer>
      <div class="row">
        <div class="col-md-6">
          <button nbButton status="primary" (click)="ref.close()">Cancelar</button>
        </div>
        <div class="col-md-6 text-right">
          <button nbButton status="danger" (click)="deleteRegistro();ref.close()">Eliminar</button>
        </div>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>
